import { Kind, IntegrationType, ProcessingState } from '@fabric/woody-client';
import { PermissionRole } from '@fabric-app/types/permission';
import { getExtensionFromFileName } from '@fabric-app/utils/manipulation';

const getKindFromExternalItem = (externalItem) => {
  if (externalItem.mimeType === "application/vnd.google-apps.folder") {
    return Kind.FOLDER;
  }
  return externalItem.kind;
};
const getExtension = (externalItem) => {
  if (externalItem.mimeType === "application/vnd.google-apps.document") {
    return "gdoc";
  }
  if (externalItem.mimeType === "application/vnd.google-apps.spreadsheet") {
    return "gsheet";
  }
  const extension = getExtensionFromFileName(externalItem.name || "");
  return extension;
};
const getData = (externalItem) => {
  if (externalItem.kind === Kind.EMAIL && "subject" in externalItem.data) {
    const result = {
      caption: "",
      emailMessage: {
        snippet: "",
        subject: externalItem.data.subject,
        from: externalItem.data.from,
        to: externalItem.data.to,
        body: externalItem.data.html,
        cc: "",
        bcc: ""
      },
      emailPreview: {
        html: externalItem.data.html
      }
    };
    return result;
  }
  return {};
};
const mapExternalToResourceDetail = (externalItem) => {
  const nextKind = getKindFromExternalItem(externalItem);
  if (nextKind === Kind.PERSON) {
    console.error("Person kind not supported yet");
    return null;
  }
  const extension = getExtension(externalItem);
  const item = {
    id: externalItem.id,
    kind: nextKind,
    mimeType: externalItem.mimeType,
    name: (externalItem.name || "").replace(`.${extension}`, ""),
    createdAt: externalItem.createdAt || "",
    publishToken: null,
    // originUrl: hit.viewUrl,
    extension,
    url: externalItem.viewUrl || "",
    thumbnail: externalItem.thumbnailUrl ? {
      lg: externalItem.thumbnailUrl,
      md: externalItem.thumbnailUrl,
      sm: externalItem.thumbnailUrl,
      xl: externalItem.thumbnailUrl,
      original: externalItem.thumbnailUrl
    } : null,
    size: "size" in externalItem.data ? externalItem.data.size : null,
    data: getData(externalItem),
    commentCount: 0,
    commentPinned: null,
    pins: [],
    descendants: [],
    // provider: 'fabric',
    originUrl: null,
    stateProcessing: ProcessingState.COMPLETED,
    label: null,
    parent: {
      id: externalItem.integrationId,
      name: "asd"
    },
    ancestors: [],
    tags: [],
    root: null,
    cover: null,
    user: null,
    modifiedAt: externalItem.modifiedAt || "",
    jobsProcessing: {
      attributes: ProcessingState.COMPLETED
    },
    description: null,
    icon: null,
    isShared: false,
    isDirectShared: false,
    isReadonly: false,
    fileUrl: externalItem.fileUrl,
    isHidden: false,
    shareToken: null,
    preferences: {},
    permission: {
      role: PermissionRole.OWNER,
      inherited: false,
      canAccessParent: true,
      hasAdded: true,
      hasAddedDirectly: true
    },
    _meta: {
      externalData: {
        integrationId: externalItem.integrationId,
        provider: IntegrationType[externalItem.provider],
        url: externalItem.viewUrl || externalItem.fileUrl,
        reference: externalItem
      }
    }
  };
  return item;
};

export { mapExternalToResourceDetail };
//# sourceMappingURL=mapExternalToResourceDetail.js.map
